import {
  xAccessor as xAreaAccessor,
  x1Accessor as x1AreaAccessor,
  yAccessor as yAreaAccessor,
  y1Accessor as y1AreaAccessor,
} from './area-accessors.js';
import {
  bandX0Accessor as x0BandAccessor,
  xMiddleBandAccessor,
  bandY0Accessor as y0BandAccessor,
  yMiddleBandAccessor,
} from './band-accessors.js';
import {
  xAccessor as xDotAccessor,
  yAccessor as yDotAccessor,
} from './dot-accessors.js';
import {
  xAccessor as xLineAccessor,
  yAccessor as yLineAccessor,
} from './line-accessors.js';
import {
  DOT_VARIANT,
  LINE_VARIANT,
  AREA_HORIZONTAL,
  AREA_VERTICAL,
  BAND_HORIZONTAL,
  BAND_VERTICAL,
} from '../../types/xy-chart-internals.js';
import type { LinearAccessors } from '../../utils/type-guards.js';

export const LINEAR_ACCESSORS: LinearAccessors = {
  [BAND_HORIZONTAL]: {
    x: xMiddleBandAccessor,
    y: y0BandAccessor,
  },
  [BAND_VERTICAL]: {
    x: x0BandAccessor,
    y: yMiddleBandAccessor,
  },
  [DOT_VARIANT]: {
    x: xDotAccessor,
    y: yDotAccessor,
  },
  [LINE_VARIANT]: {
    x: xLineAccessor,
    y: yLineAccessor,
  },
  [AREA_HORIZONTAL]: {
    x: x1AreaAccessor,
    y: yAreaAccessor,
  },
  [AREA_VERTICAL]: {
    x: xAreaAccessor,
    y: y1AreaAccessor,
  },
} as const;
